<script setup lang="ts">
import { computed } from 'vue'

import { severityPresentation } from '../../service/insightPresentation'

import { useI18n } from '@/shared/i18n'
import { Badge } from '@/shared/ui/badge'

// Exclusive pairs, keyed on severity rather than on a semantic tone — see `InsightOutcomeBadge`
// for why the primitive paints nothing (`tone="plain"`) while this table owns the colour.
const SEVERITY_TONE_CLASS: Record<string, string> = {
  needs_attention:
    'bg-[var(--ui-color-insight-attention-soft)] text-[var(--ui-color-insight-attention)]',
  opportunity:
    'bg-[var(--ui-color-insight-opportunity-soft)] text-[var(--ui-color-insight-opportunity)]',
  informational: 'bg-info-soft text-info',
  actual: 'bg-primary-subtle text-primary',
}
const NEUTRAL_TONE_CLASS =
  'bg-[var(--ui-color-insight-neutral-soft)] text-[var(--ui-color-insight-neutral)]'

const props = withDefaults(defineProps<{ value: unknown; strong?: boolean }>(), { strong: false })
const { t } = useI18n()
const presentation = computed(() => severityPresentation(props.value))
const toneClass = computed(() => SEVERITY_TONE_CLASS[presentation.value.key] ?? NEUTRAL_TONE_CLASS)
</script>

<template>
  <Badge
    class="insight-severity-badge"
    :class="[`insight-severity-badge--${presentation.key}`, toneClass]"
    tone="plain"
    :strong="strong"
    >{{ t(presentation.labelKey) }}</Badge
  >
</template>
